import {
  GET_COMPANY_LIST_SUCCESS,
  UPDATE_BROKER_SELECTED_COMPANY_SUCCESS,
  UPDATE_BROKER_SELECTED_POLICY_NO,
  GET_BROKER_SINGLE_HR_COMPANY_SUCCESS,
  GET_BROKER_LIST_SUCCESS,
} from "../actions";

const initialState = {
  companyList: [],
  selectedCompanyId: null,
  selectedCompanyName: null,
  selectedPolicyNo: null,
  brokerListData: [],
  allowOutpatient: null,
  allowInpatient: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_COMPANY_LIST_SUCCESS:
      return Object.assign({}, state, {
        companyList: action.payload.data.clients,
      });
    case UPDATE_BROKER_SELECTED_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        selectedCompanyId: action.payload.data.user.companyId,
        selectedCompanyName: action.payload.data.user.companyName,
        allowOutpatient: action.allowOutpatient,
        allowInpatient: action.allowInpatient,
      });
    case UPDATE_BROKER_SELECTED_POLICY_NO:
      return Object.assign({}, state, {
        selectedPolicyNo: action.payload.policyNo,
      });
    case GET_BROKER_SINGLE_HR_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        selectedCompanyId: action.payload.data.client[0]._id,
        selectedCompanyName: action.payload.data.client[0].name,
      });
    case GET_BROKER_LIST_SUCCESS:
      return Object.assign({}, state, {
        brokerListData: action.payload.data.brokers,
      });
    default:
      return state;
  }
}
